import { schemaGenerator } from "../utils";

const dictionary = {
  regular: {
    default: [
      "tw-bg-semantic-red-100",
      "tw-rounded-full",
      "tw-font-bold",
      "tw-text-9px",
      "tw-flex",
      "tw-items-center",
      "tw-justify-center",
      "tw-text-white",
    ],
  },
};

export const schema = schemaGenerator(dictionary);

const sizeDictionary = {
  medium: "tw-h-18px tw-w-18px",
  small: "tw-h-14px tw-w-14px",
};

export const availableSizes = Object.keys(sizeDictionary);

export const sizeClasses = (size) => sizeDictionary[size];
